import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useT } from "../../shared/i18n";

/**
 * Slim offline notice under the app bar (spec §7). `role="status"` announces it
 * once; the account menu repeats the connectivity state.
 */
export function OfflineBanner() {
  const t = useT();
  return (
    <Box
      role="status"
      data-testid="offline-banner"
      sx={{
        flexShrink: 0,
        px: 2,
        py: 0.5,
        textAlign: "center",
        bgcolor: "action.selected",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t("offlineBanner")}
      </Typography>
    </Box>
  );
}
